import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "./tokenKeys";

let redirectScheduled = false;

export function hasJwtInSessionStorage(): boolean {
  return (
    !!sessionStorage.getItem(ACCESS_TOKEN_KEY) ||
    !!sessionStorage.getItem(REFRESH_TOKEN_KEY)
  );
}

export function clearAuthSessionStorage(): void {
  sessionStorage.clear();
}

export function terminateSessionAndGoToLogin(): void {
  if (redirectScheduled) {
    return;
  }
  redirectScheduled = true;
  clearAuthSessionStorage();
  window.location.replace("/login");
}
